var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "39px",
    viewBox: "0 0 34 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.00010625 0.4047225 33.64725 0.4047225 33.64725 39 0.00010625 39"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.2--Password",
    transform: "translate(-331.000000, -307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(331.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.44145,33.2105475 C29.44145,34.36836 28.6004813,35.14056 27.3387625,35.14056 L6.30923125,35.14056 C5.04698125,35.14056 4.2060125,34.36836 4.2060125,33.2105475 L4.2060125,21.631935 C4.2060125,20.4741225 5.04698125,19.70241 6.30923125,19.70241 L27.3387625,19.70241 C28.6004813,19.70241 29.44145,20.4741225 29.44145,21.631935 L29.44145,33.2105475 Z M10.5151375,10.0533225 C10.5151375,6.772935 13.24895,4.26426 16.8237312,4.26426 C20.3990437,4.26426 23.1328562,6.772935 23.1328562,10.0533225 L23.1328562,15.8428725 L10.5151375,15.8428725 L10.5151375,10.0533225 Z M27.3387625,15.8428725 L27.3387625,10.0533225 C27.3387625,4.6498725 22.7121062,0.4047225 16.8237312,0.4047225 C10.9353562,0.4047225 6.30923125,4.6498725 6.30923125,10.0533225 L6.30923125,15.8428725 C2.73391875,15.8428725 0.00010625,18.3515475 0.00010625,21.631935 L0.00010625,33.2105475 C0.00010625,36.490935 2.73391875,39.0000975 6.30923125,39.0000975 L27.3387625,39.0000975 C30.9135437,39.0000975 33.6473562,36.490935 33.6473562,33.2105475 L33.6473562,21.631935 C33.6473562,18.3515475 30.9135437,15.8428725 27.3387625,15.8428725 Z",
    id: "Fill-1",
    fill: "#9B9B9B",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17,23 C15.7998989,23 15,23.7997979 15,24.9997474 L15,28.9997474 C15,30.1996969 15.7998989,31 17,31 C18.2001011,31 19,30.1996969 19,28.9997474 L19,24.9997474 C19,23.7997979 18.2001011,23 17,23",
    id: "Fill-4",
    fill: "#9B9B9B"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.6e768f501f0ff37b0660456cbd3e0fe0.svg";
export { ForwardRef as ReactComponent };